import { campaignRecipientSchema } from "@redotech/redo-marketing-common/campaigns/campaign-recipient-definition";
import { campaignRecipientColumnKeys } from "@redotech/redo-views-common/campaign-recipients-list-sort";
import { SortDirection } from "@redotech/redo-views-common/table";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getCampaignRecipientsCount = {
  name: "getCampaignRecipientsCount" as const,
  input: z.object({ campaignId: z.string() }),
  output: z.object({ count: z.number() }),
};

/** Attributed revenue for recipients the caller already has. */
export const getCampaignRecipientRevenue = {
  name: "getCampaignRecipientRevenue" as const,
  input: z.object({
    campaignId: z.string(),
    recipientIds: z.array(z.string()).max(200),
  }),
  output: z.object({
    revenue: z.array(
      z.object({
        recipientId: z.string(),
        revenue: z.number(),
        orders: z.number(),
      }),
    ),
  }),
};

/** A page of recipients who ordered, biggest spender first. Recipients who
 *  didn't order have no row. */
export const paginateConvertedCampaignRecipients = {
  name: "paginateConvertedCampaignRecipients" as const,
  input: z.object({
    campaignId: z.string(),
    limit: z.number().min(1).max(100).optional().default(50),
    offset: z.number().min(0).optional().default(0),
  }),
  output: z.object({
    data: z.array(
      z.object({
        recipient: campaignRecipientSchema,
        revenue: z.number(),
        orders: z.number(),
      }),
    ),
    /** Deleted recipients are dropped, so a page can be short and still
     *  have more after it. */
    hasMore: z.boolean(),
  }),
};

export const paginateCampaignRecipients = {
  name: "paginateCampaignRecipients" as const,
  input: z.object({
    campaignId: z.string(),
    lastItem: z.optional(campaignRecipientSchema),
    sort: z.optional(
      z.object({
        direction: createEnum(SortDirection),
        key: createEnum(campaignRecipientColumnKeys),
      }),
    ),
    limit: z.number().optional(),
  }),
  output: z.object({ data: z.array(campaignRecipientSchema) }),
};
